import React from "react";
import { useAppContext } from "../../AppProvider";
import { ButtonUtility } from "../../Components/common/Buttons/ButtonUtility";
import { ButtonDelete } from "../../Components/common/Buttons/ButtonDelete";
import { useIndexParcelTemplatesContext } from "./providers/Index";
import { useDeleteParcelTemplateContext } from "./providers/Delete";

const Delete: React.FC = () => {
  const { dictionary } = useAppContext();
  const { modalConfig } = useIndexParcelTemplatesContext();
  const { data, callback, loader, deleteParcelTemplates } =
    useDeleteParcelTemplateContext();

  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col">
          <h3 className="text-center">
            {modalConfig.title || dictionary.actions.delete}
          </h3>
          <label className="label-5 text-center">
            {data?.length && data.length > 1
              ? dictionary.messages.ask_to_delete_selected
              : dictionary.messages.ask_to_delete}
          </label>
        </div>
      </div>
      <div className="d-flex">
        <ButtonUtility
          className="w-50 me-2"
          onClick={() => {
            if (callback) {
              callback();
            }
          }}
        >
          {dictionary.actions.cancel}
        </ButtonUtility>
        <ButtonDelete
          className="w-50"
          onClick={() => deleteParcelTemplates()}
          disabled={loader}
          loading={loader}
        >
          {dictionary.actions.delete}
        </ButtonDelete>
      </div>
    </React.Fragment>
  );
};

export default Delete;
